import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

// import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useErrorHandler } from 'react-error-boundary';

import { useChargeStore } from '@stores/useChargeStore';
import axios from 'axios';

import { useGlobalContext } from '@contexts/global';

import { ChatieErrorCode, Platform } from '../constants';
import { IChatieAPIError } from '../model';
import { useWebView } from './webview';

export class ChatieAppError extends Error {}

export const isChatieAPIError = (error: unknown): error is IChatieAPIError => {
  if (axios.isAxiosError(error)) {
    if (error.config.baseURL === process.env.NEXT_PUBLIC_API_URL) {
      return true;
    }
  }

  return false;
};

export function useChatieErrorHandler() {
  const { t } = useTranslation();
  const { platform } = useGlobalContext();
  const { web } = useWebView();
  const router = useRouter();
  const handleError = useErrorHandler();
  const { setIsNeedCharge } = useChargeStore();

  const onError = useCallback((error: unknown) => {
    if (error instanceof ChatieAppError) {
      alert(error.message);
      return;
    }

    if (!isChatieAPIError(error)) {
      handleError(error);
      return;
    }

    if (error.response.status === 429) {
      // skip requeset throttle error
      return;
    }

    switch (error.response.data.code) {
      case ChatieErrorCode.NotAuthenticated: {
        const c = window.confirm(
          t(`로그인이 필요한 서비스입니다. 로그인 페이지로 이동하시겠습니까?`)
        );
        if (c) {
          if (platform === Platform.web) {
            return router.push('/signin');
          }
          web.leave();
          // TODO: next 로그인 페이지
          // const { asPath } = router;
          // router.push(
          //   `/signin${toQueryString({ next: encodeURIComponent(asPath) })}`
          // );
        }
        break;
      }

      case ChatieErrorCode.PermissionDenied: {
        alert(t('해당 기능을 사용할 권한이 없습니다.'));
        return;
      }

      case ChatieErrorCode.PaidTapShortageError: {
        setIsNeedCharge(true);
        return;
      }

      default: {
        const { errors } = error.response.data;
        const errorKeys = Object.keys(errors);
        if (errorKeys.length) {
          alert(errors[errorKeys[0]][0]);
        } else {
          alert(
            error.response.data.message ??
              t('문제가 발생하였습니다. 잠시 후 다시 시도해주세요.')
          );
        }
      }
    }
  }, []);

  return onError;
}
